import { DecimalFormat } from "@omni/types/components/price/enums/decimalFormat.enum";
import { strikeThrough } from "@omni/ui/components/Price//components/strikeThrough.style";
import { conversion } from "@omni/ui/components/Price/components/conversion.style";
import { main } from "@omni/ui/components/Price/components/main.style";
import { tv } from "tailwind-variants";

import { PriceStyleTokens } from "@/components/Price/price.tokens";

const base = tv({
    base: ["tw:flex tw:flex-col tw:w-fit tw:items-end"]
});

export const PriceStyle = Object.assign(base, {
    main: main,
    conversion: conversion,
    strikeThrough: strikeThrough,
    decimalFormat: DecimalFormat.Dash
}) satisfies PriceStyleTokens;
